import React from "react";
import { Info } from "./Info";
import { Footer } from "./Footer";
import Header from "./Header";
import { ProductImage } from "./ProductImage";

function Pending(props) {
  return (
    <div className="bg-white w-full lg:w-185 lg:mx-auto lg:my-15 bg-white rounded shadow-lg overflow-hidden">
      <div className="p-8 lg:p-15">
        <Header />
        <ProductImage />
        <div className="mb-8">
          <p className="text-3xl text-center">活動還未開始，請瘋狂Refresh!</p>
        </div>
        <Info />
      </div>
      <Footer />
    </div>
  );
}

export default Pending;
